module.exports = __webpack_public_path__ + "static/media/SFiOBOA_nn_primærlogo_sentrert_logo_neg.f4a92f31.svg";